import {
  type CommonNavigatorParams,
  type NativeStackScreenProps,
} from '#/lib/routes/types'
import {disclosure2257} from '#/lib/policies'
import {PolicyDocument} from '#/components/PolicyDocument'

type Props = NativeStackScreenProps<CommonNavigatorParams, 'Disclosure2257'>
export const Disclosure2257Screen = (_props: Props) => {
  return <PolicyDocument {...disclosure2257} />
}
